import script from "./StringPeelForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StringPeelForm.vue?vue&type=script&setup=true&lang=js"

import "./StringPeelForm.vue?vue&type=style&index=0&id=65b7052c&lang=css"

const __exports__ = script;

export default __exports__